import { Component, computed, inject, input, resource, signal } from '@angular/core';
import { Api } from '../../../../core/clients/omni-core/api';
import { getPriceCurveSummary } from '../../../../core/clients/omni-core/functions';
import { form, FormField } from '@angular/forms/signals';
import { NgIcon } from '@ng-icons/core';
import { SwitchBar, SwitchBarOption, Button, Skeleton } from 'excellence-ui';
import { ResponsiveValue } from '../../../../shared/components/responsive-value/responsive-value';
import { GermanNumberPipe } from '../../../../shared/pipes/german-number-pipe';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { TranslocoPipe } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-analysis-dashboard-hpfc-kpi-card',
  imports: [
    FormField,
    NgIcon,
    SwitchBar,
    SwitchBarOption,
    ResponsiveValue,
    Button,
    GermanNumberPipe,
    Skeleton,
    ErrorComponent,
    TranslocoPipe,
    RouterLink,
  ],
  templateUrl: './analysis-dashboard-hpfc-kpi-card.html',
})
export class AnalysisDashboardHpfcKpiCard {
  private api = inject(Api);

  organizationId = input.required<string | null>();

  protected kpi = resource({
    loader: () => this.api.invoke(getPriceCurveSummary),
  });

  private settings = signal<{ type: 'HIGH' | 'LOW' | 'AVERAGE' }>({
    type: 'AVERAGE',
  });
  protected settingsForm = form(this.settings);

  protected todayValue = computed(() => {
    const value = this.kpi.hasValue() ? this.kpi.value() : null;
    switch (this.settings().type) {
      case 'AVERAGE':
        return value?.today.average;
      case 'HIGH':
        return value?.today.high;
      case 'LOW':
        return value?.today.low;
    }
  });

  protected tomorrowValue = computed(() => {
    const value = this.kpi.hasValue() ? this.kpi.value() : null;
    switch (this.settings().type) {
      case 'AVERAGE':
        return value?.tomorrow.average;
      case 'HIGH':
        return value?.tomorrow.high;
      case 'LOW':
        return value?.tomorrow.low;
    }
  });

  protected weekValue = computed(() => {
    const value = this.kpi.hasValue() ? this.kpi.value() : null;
    switch (this.settings().type) {
      case 'AVERAGE':
        return value?.week.average;
      case 'HIGH':
        return value?.week.high;
      case 'LOW':
        return value?.week.low;
    }
  });
}
